import styled from 'styled-components'
import { Row } from 'react-grid-system'

export const ReservationFormContainer = styled.div`
  margin-top: 30px;
`
export const ReservationSpinnerContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ReservationFormRow = styled(Row)`
  /* margin: 25px 0px; */
`

export const ReservationFormFieldset = styled.fieldset`
  border-radius: 8px;
  padding: 0px 5px 5px 5px;
  min-height: 48px;
  border: 1px solid #f0eff0;
  margin: 8px 0px;
`

export const ReservationFormLegend = styled.legend`
  padding: 0px 5px;
  font-weight: 600;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 13px;
`

export const ReservationFormInput = styled.input`
  border: none;
  width: 100%;
  padding: 5px;
  font-size: 16px;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.fonts.main};
  &:focus-visible {
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.black};
  }
`

export const ReservationFormSelect = styled.select`
  border: none;
  width: 100%;
  height: 20px;
  &:focus-visible {
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.black};
  }
`

export const ReservationFormTextArea = styled.textarea`
  border: none;
  resize: none;
  width: 100%;

  &:focus-visible {
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.black};
  }

  &::-webkit-scrollbar {
    display: none;
  }
`

export const ReservationFormGroup = styled.div`
  margin: 15px 0px;
`

export const ReservationFormCheckInput = styled.input`
  margin-left: 14px;
  border-radius: 10px;
  padding: 8px;
  font-size: 15px;
  border: 2px solid #c2c5c9;
  &:focus-visible {
    outline: none;
  }
`

export const ReservationFormGroupPrice = styled.div`
  padding: 10px;
  display: flex;
  border: 1px solid #858c94;
  box-sizing: border-box;
  border-radius: 8px;
`

export const ReservationFormGroupPriceText = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 16px;
`

export const ReservationFormGroupPriceInput = styled.input`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding: 0px;
  margin: 0px;
  border: none;
  margin-left: 10px;
  width: 100%;
  color: #09101d;
  &:focus-visible {
    outline: none;
  }
`

export const ReservationNameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ReservationPaymentStatusContainer = styled.div`
  position: absolute;
  right: 45px;
  top: 66px;
  height: 28px;
`

export const ReservationButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  margin-bottom: 25px;
`

export const NoPaymentsMsg = styled.span`
  margin-left: 40%;
`
